// extracted by mini-css-extract-plugin
export default {"token":"b2pR7B","hover":"c2pR7B","disabled":"d2pR7B"};